import { Component, OnInit } from '@angular/core';
import { SmsService } from 'src/app/services/sms.service';
import { ToastrService } from 'ngx-toastr';
import parsePhoneNumber from 'libphonenumber-js';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-report-page',
  templateUrl: './report-page.component.html',
  styleUrls: ['./report-page.component.css']
})
export class ReportPageComponent implements OnInit {
  isLoading = false;

  constructor(
    private SmsService: SmsService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
  }

  enviar() {
    // Remover clases de invalido a input
    document.getElementById('nombre').classList.remove('is-invalid')
    document.getElementById('email').classList.remove('is-invalid')
    document.getElementById('problema').classList.remove('is-invalid')

    // Obteniendo datos de los inputs
    var nombre = (<HTMLInputElement>document.getElementById("nombre")).value;
    var email = (<HTMLInputElement>document.getElementById("email")).value;
    var problema = (<HTMLInputElement>document.getElementById("problema")).value;

    // Validacion 
    if (nombre.length < 3) {
      document.getElementById('nombre').classList.add('is-invalid')
    } else if (email.length < 3) {
      document.getElementById('email').classList.add('is-invalid')
    } else if (problema.length > 250) {
      document.getElementById('problema').classList.add('is-invalid')
    } else {
      var texto = "⚽ *TuQuinielaYa* ⚽ \n\n*Soporte Tecnico:* El usuario " + nombre + " ("+ email +"). \n\n*Presenta el siguiente problema:* \n" + problema;
      var numero = '+584129076968'; // Este es el telefono al que le llegaran los reportes de problemas de la plataforma.
      this.SmsService.enviar(numero, texto);

      // Limpiar campos
      (<HTMLInputElement>document.getElementById("nombre")).value = "";
      (<HTMLInputElement>document.getElementById("email")).value = "";
      (<HTMLInputElement>document.getElementById("problema")).value = "";

      Swal.fire({
        icon: 'success',
        title: 'Enviado',
        text: 'Su mensaje fue enviado a los administradores de la plataforma. En breves momentos se contactaran con usted para darle respuesta a su problema.',
        confirmButtonColor: '#ef6603',
      })
    }

  }

}
